import { render } from "./StreamNavigationCard.vue?vue&type=template&id=2a4d99d8&scoped=true"
import script from "./StreamNavigationCard.vue?vue&type=script&lang=js"
export * from "./StreamNavigationCard.vue?vue&type=script&lang=js"

import "./StreamNavigationCard.vue?vue&type=style&index=0&id=2a4d99d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a4d99d8"

export default script